import React, { useCallback, useEffect, useState } from 'react'
import { NativeCurrency, Token } from '@monadex/sdk'
import { CurrencySearchModal, CurrencyLogo } from '@/components'
import { Box } from '@mui/material'
import { sendGAEvent } from '@next/third-parties/google'

interface CurrencySelectProps {
  title?: string
  handleCurrencySelect: (currency: Token) => void
  currency: Token | NativeCurrency | undefined
  otherCurrency?: Token | NativeCurrency | undefined
  id?: string
  bgClass?: string
  children?: any
}

const CurrencySelect: React.FC<CurrencySelectProps> = ({
  handleCurrencySelect,
  currency,
  otherCurrency,
  bgClass,
  children
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const handleOpenModal = useCallback(() => {
    setModalOpen(true)
  }, [])

  useEffect(() => {
    sendGAEvent(
      'event',
      'select currency',
      {
        label: 'currency_selected',
        value: currency?.symbol
      })
  },[])
  return (
    <Box className='rounded-lg flex justify-between items-center gap-3'>
      <Box
        className={
          bgClass === undefined
            ? `flex items-center gap-3 cursor-pointer p-3 rounded-lg border ${currency ? 'border-primary border-opacity-40' : 'border-primary border-opacity-20 shadow-md'}`
            : bgClass
        }
        onClick={handleOpenModal}
      >
        {currency != null
          ? (
            <Box className='flex items-center gap-2'>
              <CurrencyLogo currency={currency} size='28px' />
              <p className='ml-1'>{currency?.symbol}</p>
            </Box>
            )
          : (
            <p className='text-primary/80'>Select token</p>
            )}
        {children}
      </Box>
      {modalOpen && (
        <CurrencySearchModal
          isOpen={Boolean(modalOpen)}
          onDismiss={() => {
            setModalOpen(false)
          }}
          onCurrencySelect={handleCurrencySelect}
          selectedCurrency={currency}
          showCommonBases
          otherSelectedCurrency={otherCurrency}
        />
      )}
    </Box>
  )
}

export default CurrencySelect
